export const DEFAULT_FILTERS = {
  sort: 'price-asc',
  minPrice: 0,
  maxPrice: 5000,
  stops: 'any',
  cabin: 'any',
  airlines: [],
  minStars: 0,
  minRating: 0,
  carType: 'any',
  company: 'any',
  transmission: 'any',
  cabinType: 'any',
  minNights: 0,
};

export function getPriceBounds(results) {
  if (!results.length) return { min: 0, max: 3000 };
  const prices = results.map((r) => r.price);
  return {
    min: Math.floor(Math.min(...prices)),
    max: Math.ceil(Math.max(...prices)),
  };
}

export function getUniqueAirlines(results) {
  return [...new Set(results.map((r) => r.airlineCode || r.airline).filter(Boolean))].sort();
}

export function getUniqueCompanies(results) {
  return [...new Set(results.map((r) => r.company).filter(Boolean))].sort();
}

export function applyFlightFilters(results, filters) {
  return results.filter((r) => {
    if (r.price < filters.minPrice || r.price > filters.maxPrice) return false;
    if (filters.stops === 'nonstop' && r.stops !== 0) return false;
    if (filters.stops === '1' && r.stops !== 1) return false;
    if (filters.stops === '2plus' && r.stops < 2) return false;
    if (filters.cabin !== 'any' && r.cabin !== filters.cabin.toUpperCase()) return false;
    if (filters.airlines.length > 0) {
      const code = r.airlineCode || r.airline;
      if (!filters.airlines.includes(code)) return false;
    }
    return true;
  });
}

export function applyHotelFilters(results, filters) {
  return results.filter((r) => {
    if (r.price < filters.minPrice || r.price > filters.maxPrice) return false;
    if (r.stars < filters.minStars) return false;
    if (parseFloat(r.rating) < filters.minRating) return false;
    return true;
  });
}

export function applyCarFilters(results, filters) {
  return results.filter((r) => {
    if (r.price < filters.minPrice || r.price > filters.maxPrice) return false;
    if (filters.carType !== 'any' && r.type !== filters.carType) return false;
    if (filters.company !== 'any' && r.company !== filters.company) return false;
    if (filters.transmission !== 'any' && r.transmission !== filters.transmission) return false;
    return true;
  });
}

export function applyPackageFilters(results, filters) {
  return results.filter((r) => {
    if (r.price < filters.minPrice || r.price > filters.maxPrice) return false;
    if (filters.minNights > 0 && r.nights < filters.minNights) return false;
    return true;
  });
}

export function applyCruiseFilters(results, filters) {
  return results.filter((r) => {
    if (r.price < filters.minPrice || r.price > filters.maxPrice) return false;
    if (filters.cabinType !== 'any' && r.cabin !== filters.cabinType) return false;
    if (filters.minNights > 0 && r.nights < filters.minNights) return false;
    return true;
  });
}

export function sortResults(results, sort, type) {
  const list = [...results];
  switch (sort) {
    case 'price-desc':
      return list.sort((a, b) => b.price - a.price);
    case 'duration-asc':
      if (type === 'flights') {
        return list.sort((a, b) => (a.durationMinutes || 0) - (b.durationMinutes || 0));
      }
      return list;
    case 'duration-desc':
      if (type === 'flights') {
        return list.sort((a, b) => (b.durationMinutes || 0) - (a.durationMinutes || 0));
      }
      return list;
    case 'rating-desc':
      return list.sort((a, b) => parseFloat(b.rating || 0) - parseFloat(a.rating || 0));
    case 'stars-desc':
      return list.sort((a, b) => (b.stars || 0) - (a.stars || 0));
    case 'depart-asc':
      return list.sort((a, b) => (a.departAt || '').localeCompare(b.departAt || ''));
    default:
      return list.sort((a, b) => a.price - b.price);
  }
}

export function filterResults(type, results, filters) {
  let filtered = results;
  if (type === 'flights') filtered = applyFlightFilters(results, filters);
  else if (type === 'hotels') filtered = applyHotelFilters(results, filters);
  else if (type === 'cars') filtered = applyCarFilters(results, filters);
  else if (type === 'packages') filtered = applyPackageFilters(results, filters);
  else if (type === 'cruises') filtered = applyCruiseFilters(results, filters);
  return sortResults(filtered, filters.sort, type);
}
